import { formatMetres } from "../../../CableTakeoffTabV3/formatMetres";
import type { FormatQuantityValue } from "./types";

// Every row formats two numbers, and building an Intl formatter costs ~50x more
// than reusing one, so instances are kept per locale.
const countFormatterByLocale = new Map<string, Intl.NumberFormat>();

const getCountFormatter = (locale: string): Intl.NumberFormat => {
  const existingFormatter = countFormatterByLocale.get(locale);
  if (existingFormatter) return existingFormatter;

  const formatter = new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0,
  });
  countFormatterByLocale.set(locale, formatter);
  return formatter;
};

// Metres go through the app's own formatter so the comparison never invents a
// precision the rest of the surveyor doesn't use.
export const formatQuantityValue: FormatQuantityValue = ({
  value,
  language,
  kind,
}) => {
  if (kind === "cables") return `${formatMetres({ value, language })} m`;

  return getCountFormatter(
    language.startsWith("de") ? "de-DE" : "en-GB",
  ).format(value);
};
